<template>
  <q-card-section class="auth-loading-panel column col items-center justify-center gap-lg q-pa-xl">
    <div class="auth-loading-panel-loader flex flex-center">
      <q-spinner
        size="7rem"
        color="brand-dark"
        :thickness="1.5"
        aria-hidden="true"
      />
      <lucide-icon
        name="shield-check"
        size="48px"
        :stroke-width="1.5"
        color="brand"
        class="auth-loading-panel-loader-icon"
        aria-hidden="true"
      />
    </div>

    <div
      class="column items-center gap-xxl text-center"
      role="status"
      aria-live="polite"
    >
      <h1 class="text-28 text-font-semibold">{{ screenCopy.headline }}</h1>

      <div
        v-if="screenCopy.subline?.length"
        class="onboarding-subline column items-center gap-xs text-16 text-primary"
      >
        <p
          v-for="(line, index) in screenCopy.subline"
          :key="index"
          class="q-ma-none"
        >
          {{ line }}
        </p>
      </div>
    </div>
  </q-card-section>
</template>

<script setup>
  import { computed } from 'vue'

  import { useAuthStore } from 'src/stores/auth'

  import { AUTH_SCREEN_COPY } from 'src/services/consts/app.const'

  // SessionGate has already decided the session is in flight — signing in and
  // signing out share this spinner, and only the copy differs.

  const authStore = useAuthStore()

  const screenCopy = computed(() =>
    authStore.isLoggingOut ? AUTH_SCREEN_COPY.logout : AUTH_SCREEN_COPY.loading
  )
</script>

<style lang="scss">
  .auth-loading-panel {
    position: relative;
    z-index: 2;
    min-height: 0;

    .auth-loading-panel-loader {
      position: relative;
      width: 7rem;
      height: 7rem;

      .auth-loading-panel-loader-icon {
        position: absolute;
        animation: pulse 1.5s ease-in-out infinite;

        @media (prefers-reduced-motion: reduce) {
          animation: none;
        }
      }
    }
  }
</style>
